import { useRef, useEffect } from "react";

const Modal = ({ openModal, setOpenModal, children }) => {
  const documentModelRef = useRef();
  
  useEffect(() => {
    document.addEventListener("keydown", (e) =>
      e.key === "Escape" && openModal ? setOpenModal(false) : null
    );
    return () =>
      document.removeEventListener("keydown", (e) =>
        e.key === "Escape" && openModal ? setOpenModal(false) : null
      );
  }, [openModal, setOpenModal]);

  return (
    <>
      {openModal && (
        <div
          className="modal"
          id="documentModel"
          tabIndex="-1"
          aria-hidden="true"
          style={{
            display: "block",
            background: "rgba(0, 0, 10, 0.8)",
            heigth: "100%",
          }}
          ref={documentModelRef}
          onClick={(e) => {
            documentModelRef.current === e.target && setOpenModal(false);
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">{children}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Modal;
